module.exports = require("@jonbrennecke/react-native-media");